import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Prevent SSR execution
    if (typeof window === "undefined") return;

    // Scroll to top
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });

    // Dynamically import WOW (client only)
    import("wow.js").then((WOWModule) => {
      const WOW = WOWModule.default;

      const wow = new WOW({
        live: false,
      });

      wow.init();
      wow.sync();
    });

  }, [pathname]);

  return null;
};

export default ScrollToTop;